import { createRouter, createWebHistory } from "vue-router";

import "nprogress/nprogress.css";
import "@/app/layouts/types";
import modules from "@/app/router/modules";
import { carryFilterParams } from "@/app/router/utils/filterCarry";
import { authGuard, setRouterForGuards } from "@/app/router/utils/guards";
import { recordPageVisit, visitForNavigation } from "@/features/admin/pageVisits";
import { progress } from "@/shared/lib/browser/progress";

const router = createRouter({
  history: createWebHistory(),
  routes: modules,
});

// Provide router instance to guards for Smart Redirects
setRouterForGuards(router);

router.beforeEach(async (to, from) => {
  progress.start();

  const title = (to.meta as { title?: string }).title;
  document.title = title ? `${title} | SO Insights` : "SO Insights";

  const carried = carryFilterParams(to, from);
  if (carried) return carried;

  return authGuard(to, from);
});

router.afterEach((to, from, failure) => {
  progress.done();
  const visit = visitForNavigation(to, from, failure);
  if (visit) void recordPageVisit(visit);
});

router.onError(() => {
  progress.done();
});

export default router;
